"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(r,g,b){r/=255,g/=255,b/=255;var max=Math.max(r,g,b),min=Math.min(r,g,b),h=void 0,s=void 0,d=max-min;return s=0===max?0:d/max,max===min?h=0:(max===r?h=(g-b)/d+(g<b?6:0):max===g?h=(b-r)/d+2:max===b?h=(r-g)/d+4:void 0,h/=6),[h,s,max]};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/__utils/helpers/rgbToHsv.js
// module id = 274
// module chunks = 0